<template>
  <div class="dd-col__header">
    {{ title }}
    <span class="dd-col__counter pin">{{ number(counter) }}</span>
  </div>
</template>

<script>

import { number } from '@elements/number-formatter';

export default {
  name: 'DashboardColumnHeader',
  props: {
    title: { type: String, default: '' },
    counter: { type: Number, default: 0 },
  },
  methods: {
    number,
  },
};
</script>
